import "./extend/object.js";
import "./extend/dom.js";

class Scroller {

   constructor(settings) {
      
      let defaults = {
         transitionDuration: 200,
         bufferSize: 1,
         threshold: 50
      };
      
      this.set = Object.extend(true, defaults, settings);
      
      this.elMain = HTMLElement.createFromHTML(
         '<div class="scroller">'
       + '   <div class="container">'
       + '   </div>'
       + '</div>'
      );   

      this.elContainer = this.elMain.querySelector('.container');

      this.loadItems();

      this.x0 = null;
      this.y0 = null;
      this.mousedown = false;

      this.elContainer.style.setProperty('--i', this.currentIndex);
      this.elContainer.style.setProperty('--n', this.cntItems);
      this.elContainer.style.setProperty('--td', this.set.transitionDuration + 'ms');


      this.elContainer.addEventListener('mousedown', (e) => this.dragStart(e), false);
      this.elContainer.addEventListener('touchstart', (e) => this.dragStart(e), false);
   
      this.elContainer.addEventListener('mousemove', (e) => this.drag(e), false);
      this.elContainer.addEventListener('touchmove', (e) => this.drag(e), false);
   
      this.elContainer.addEventListener('mouseup',  (e) => this.move(e), false);
      this.elContainer.addEventListener('touchend', (e) => this.move(e), false);

      this.elContainer.addEventListener('mouseleave', (e) => this.move(e), false);

   }

   loadItems() { }

   unify(e) {	return e.changedTouches ? e.changedTouches[0] : e };

   dragStart(e) {
      this.x0 = this.unify(e).clientX;
      this.y0 = this.unify(e).clientY;
      this.elContainer.classList.toggle('smooth', !(this.mousedown = true));
   };

   drag(e) {
      
      //e.preventDefault();
      let dX = Math.abs(this.unify(e).clientX - this.x0);
      let dY = Math.abs(this.unify(e).clientY - this.y0);
      if (this.mousedown) this.dragging = true;

      if (dX < this.set.threshold || dX < dY) {
      }
      else {
         if (this.mousedown) this.elContainer.style.setProperty('--tx', `${Math.round(this.unify(e).clientX - this.x0)}px`);
      }

   };

   move(e) {
      setTimeout(() => this.dragging = false, 0);

      if (this.mousedown) {
         let dx = this.unify(e).clientX - this.x0;
         let s = Math.sign(dx);

         if (Math.abs(dx) < this.set.threshold) s = 0;
         this.scroll(s);
      }
   }

   scroll(s) {
      if (this.onBeforeMove) this.onBeforeMove(this.elContainer.children[this.currentIndex - s], s);

      if ((this.currentIndex > 0 || s < 0) && (this.currentIndex < this.cntItems - 1 || s > 0)) {
         this.elContainer.style.setProperty('--i', this.currentIndex -= s);
      }
      this.elContainer.style.setProperty('--tx', '0px');
      this.elContainer.classList.toggle('smooth', !(this.mousedown = false));
      this.x0 = null;
      this.y0 = null;
      if (this.onMoveEnd) {
         setTimeout(() => { this.onMoveEnd(s)}, this.set.transitionDuration );
      }
   }

   getCurrentElement() {
      return this.elContainer.children[this.currentIndex];
   }

   getElement() {
      return this.elMain;
   }

}

export class StaticScroller extends Scroller {

   constructor(settings) {
      super(settings);

   }

   loadItems() {
      for (let el of this.set.items) {
         el.classList.add('item');
         this.elContainer.appendChild(el);
      }
      this.cntItems = this.set.items.length;
      this.currentIndex = 0;

   }

}


export class DynamicScroller extends Scroller {

   constructor(settings) {
      super(settings);

      this.renderOrder = [];
      this.renderOrder.push(this.set.bufferSize);
      for (let i=1; i <= this.set.bufferSize; ++i) {
         this.renderOrder.push(this.set.bufferSize - i);
         this.renderOrder.push(this.set.bufferSize + i);
      }
   
   }

   loadItems() {

      this.cntItems = this.set.bufferSize * 2 + 1;
      this.elContainer.empty();

      for (let i=0; i < this.cntItems; ++i) {
         let el = document.createElement('div');
         el.classList.add('item');
         this.elContainer.appendChild(el);
      }

      this.currentIndex = this.set.bufferSize;

   }

   getCurrentElement() {
      return this.elContainer.children[this.currentIndex];
   }

   getElements() {
      return [...this.elContainer.children];
   }

   
   onFlipped(element, s) {

      element.dataset.rendering = false;
      element.dataset.rendered = false;
      this.fillBuffer();

   }

   onMoveEnd(s) {

      if (s === 0 ) return;

      this.elContainer.classList.toggle('smooth', false);
      let flippedElement = s < 0 ? this.elContainer.firstElementChild : this.elContainer.lastElementChild;
      if (s < 0)  this.elContainer.appendChild(this.elContainer.firstElementChild);
      else        this.elContainer.insertBefore(this.elContainer.lastElementChild, this.elContainer.firstChild);
      this.currentIndex = this.set.bufferSize;
      this.elContainer.style.setProperty('--i', this.currentIndex);
      if (this.onFlipped) this.onFlipped(flippedElement, s);

   }

   async redrawBuffer() {
      this.elContainer.querySelectorAll('.item').forEach(item => item.dataset.rendered = item.dataset.rendered = false);
      this.fillBuffer();
   }

   async fillBuffer() {
      
      for (let i=0; i<this.renderOrder.length; ++i) {
         let el = this.elContainer.children[this.renderOrder[i]];

         // Wenn das Element schon gerendert wurde oder gerade gerendert wird: nichts machen
         if (el.dataset.rendered === 'true' || el.dataset.rendering === 'true') continue;

         // Element rendern: zuerst das rendering-Flag setzen, dann rendern
         el.dataset.rendering = true;
         await this.renderItem(el);

         // Wenn das rendering-Flag immer noch gesetzt ist (d.h. wenn das Element nicht inzwischen geflippt wurde):
         // rendering-Flag und rendered-Flag entsprechend setzen.
         if (el.dataset.rendering) {
            el.dataset.rendering = false;
            el.dataset.rendered = true;
         }
      }

   }

}

export class YearScroller extends DynamicScroller {

   constructor(settings, parent) {
      super({ transitionDuration: 400 });

      this.parent = parent;
 
      // Render-order festlegen. Diese bestimmt, in welcher Reihenfolge der Buffer gefüllt wird.
      // Im Fall des Jahres soll zuerst der aktuelle Tag und die zurückligeneden Tage gefüllt werden,
      // danach erst die in der Zukunft liegenden.
      this.renderOrder = [];
      for (let i=this.set.bufferSize; i >= 0; --i) this.renderOrder.push(i);
      for (let i=this.set.bufferSize+1; i<this.elContainer.children.length; ++i) this.renderOrder.push(i);
 
   }
 
   setCurrentYear(year) {

      this.loadItems();
      this.currentYear = year;

      // Die einzelnen Buffer-Elemente mit den Daten der Jahre füllen
      for (let i=0; i < this.elContainer.children.length; ++i) {
         const el = this.elContainer.children[i];
         el.dataset.year = (this.currentYear + i) - this.set.bufferSize;
         el.dataset.rendering = el.dataset.rendered = false;
         el.classList.add('year');
      }

      // Buffer laden
      this.fillBuffer();

   }
    
    onFlipped(element, s) {
 
      // aktuelles Datum anpassen
      if (s < 0) this.currentYear++;
      else       this.currentYear--

      // dem geflippeten Element das entsprechende Jahr zuweisen
      element.dataset.year = this.currentYear + this.set.bufferSize * -s;
      this.parent.changeMonth(this.currentYear);

      super.onFlipped(element, s);
 
   }
 
   async renderItem(element) {
      element.innerHTML = element.dataset.year;
   }
 
}
 
export class MonthScroller extends DynamicScroller {

   constructor(settings, parent) {
      super({ transitionDuration: 400 });

      this.parent = parent;
 
      // Render-order festlegen. Diese bestimmt, in welcher Reihenfolge der Buffer gefüllt wird.
      // Im Fall des Jahres soll zuerst der aktuelle Tag und die zurückligeneden Tage gefüllt werden,
      // danach erst die in der Zukunft liegenden.
      this.renderOrder = [];
      for (let i=this.set.bufferSize; i >= 0; --i) this.renderOrder.push(i);
      for (let i=this.set.bufferSize+1; i<this.elContainer.children.length; ++i) this.renderOrder.push(i);
 
   }
 
   setCurrentDate(date) {

      this.loadItems();
      this.currentDate = date;


      // Die einzelnen Buffer-Elemente mit den Daten füllen
      for (let i=0; i < this.elContainer.children.length; ++i) {
         const el = this.elContainer.children[i];
         let d = new Date(this.currentDate);
         d.setMonth((this.currentDate.getMonth() + i) - this.set.bufferSize, 1);
         el.dataset.date = d.isoDate();
         el.dataset.rendering = el.dataset.rendered = false;
         el.classList.add('month');
         el.createElement('div', 'month-title');
         el.createElement('div', 'day-grid');
      }

      this.parent.changeYear(this.currentDate.getFullYear());

      // Buffer laden
      this.fillBuffer();

   }

   onBeforeMove(element, s) {
      this.parent.renderSelection(element);
   }

   
    
   onFlipped(element, s) {
 
      // aktuelles Datum anpassen
      this.currentDate.setMonth(this.currentDate.getMonth() + -s, 1);

      // dem geflippeten Element das entsprechende Datum zuweisen
      let d = new Date(this.currentDate);
      d.setMonth(d.getMonth() + this.set.bufferSize * -s);

      element.dataset.date = d.isoDate();
      this.parent.changeYear(this.currentDate.getFullYear());

      super.onFlipped(element, s);
 
   }
 
   async renderItem(element) {
      let d = new Date(Date.fromString(element.dataset.date));
      //element.innerHTML = d.isoDate();
      this.parent.renderMonth(element);
   }
 
 }
